import { OPTIMIZELY_FEATURE_OFF, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import EnvironmentUtils from '@spothero/utils/environment';
import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
export const useDesktopSearchRefreshedVariation = () => {
    const variation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_DESKTOP_WEB_DATETIME_PICKER);
    const isMobileDevice = EnvironmentUtils.isMobileDevice();
    const parkingType = useSelector(getParkingType);
    if (window?.location?.pathname === '/search' &&
        !isMobileDevice &&
        (parkingType === 'transient' ||
            parkingType === 'event' ||
            parkingType === 'monthly' ||
            parkingType === 'power_booking' ||
            parkingType === 'airport')) {
        return variation;
    }
    return OPTIMIZELY_FEATURE_OFF;
};
